<template>
  <div class="report-options">
    <div class="close-header">
      <div v-on:click="onClose" class="upper-close px-3 pt-1">
        <i class="fa-solid fa-x"></i>
      </div>
    </div>
    <div class="main-content">
      <div
        class="d-flex flex-column align-items-center justify-content-center h-100 gap-4 mt-5"
      >
        <IconBadge>
          <i class="fa fa-check m-0"></i>
        </IconBadge>

        <h2 class="text-center">
          {{
            cardFrozen
              ? t("CL_TRANSACTIONS.REPORT_SENT_CARD_FROZEN")
              : t("CL_TRANSACTIONS.REPORT_SENT")
          }}
        </h2>

        <p class="text-center">
          {{ t("CL_TRANSACTIONS.REPORT_WILL_BE_REVIEWED") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconBadge from "@/shared-components/ui/IconBadge.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

const { t } = useI18n();

defineProps<{
  cardFrozen?: boolean | undefined;
}>();

const emit = defineEmits<{
  (e: "close"): void;
}>();
const onClose = () => {
  emit("close");
};
</script>

<style>
.main-content {
  flex-grow: 1;
  padding: 50px;
  overflow-y: auto;
  font-family: Inter;
}

.report-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.close-header {
  height: 56px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-bottom: 1px solid #d5d5d5;
  font-family: Inter;
}
</style>
